import { z } from 'zod';

import { MantineThemeColors } from '#core/lib/formatters/colors.ts';

type ColorType = (typeof MantineThemeColors)[number];

function _isValidColor(color: string): color is ColorType {
  return MantineThemeColors.some((value) => value === color);
}

export const ColorSchema: z.ZodType<string | ColorType> = z
  .enum(MantineThemeColors)
  .describe('Color name from Mantine theme palette (e.g., "blue", "red", "green", "orange")');

export type ColorSchema = z.infer<typeof ColorSchema>;

/**
 * Schema for Mantine color shade values (0-9).
 * Lower values are lighter, higher values are darker.
 * Shade 6 is the default/primary shade in most Mantine themes.
 */
export const ShadeSchema = z
  .number()
  .int()
  .min(0)
  .max(9)
  .describe('Color shade intensity (0-9). Lower = lighter, higher = darker. Default is 6.');

export type ShadeSchema = z.infer<typeof ShadeSchema>;
